import React, { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/auth';
import api from '../../services/api';
import InvoiceCard from './InvoiceCard';

import styles from './HomePage.module.scss';
import { InvoiceViewModel } from '../../models/Invoice/InvoiceViewModel';

export default function HomePage() {
  const {
    user: { organization },
    isAdmin,
  } = useAuth();

  const [invoicesWip, setInvoicesWip] = useState([] as InvoiceViewModel[]);
  const [invoicesBlocked, setInvoicesBlocked] = useState(
    [] as InvoiceViewModel[]
  );
  const [invoicesCompleted, setInvoicesCompleted] = useState(
    [] as InvoiceViewModel[]
  );
  const [isinvoicesWipLoading, setIsinvoicesWipLoading] = useState(true);
  const [isinvoicesBlockedLoading, setIsinvoicesBlockedLoading] =
    useState(true);
  const [isinvoicesCompletedLoading, setIsinvoicesCompletedLoading] =
    useState(true);

  async function getInvoicesWip() {
    if (organization) {
      setIsinvoicesWipLoading(true);
      const response = await api.get(
        `organizations/${organization.id}/invoices/wip`
      );
      setInvoicesWip(response.data.data);
      setIsinvoicesWipLoading(false);
    }
  }

  async function getInvoicesCompleted() {
    if (organization) {
      setIsinvoicesCompletedLoading(true);
      const response = await api.get(
        `organizations/${organization.id}/invoices/completed`
      );
      setInvoicesCompleted(response.data.data);
      setIsinvoicesCompletedLoading(false);
    }
  }

  async function getInvoicesBlocked() {
    if (organization) {
      setIsinvoicesBlockedLoading(true);
      const response = await api.get(
        `organizations/${organization.id}/invoices/blocked`
      );
      setInvoicesBlocked(response.data.data);
      setIsinvoicesBlockedLoading(false);
    }
  }

  useEffect(() => {
    if (isAdmin) {
      getInvoicesWip();
      getInvoicesCompleted();
      getInvoicesBlocked();
    }
  }, [organization, isAdmin]);

  return isAdmin ? (
    <div className={`mt-4 ${styles.invoicesWrapper}`}>
      <InvoiceCard
        isLoading={isinvoicesWipLoading}
        invoices={invoicesWip}
        header='Serviços não concluídos'
      />
      <InvoiceCard
        isLoading={isinvoicesCompletedLoading}
        invoices={invoicesCompleted}
        header='Serviços realizados / Aguardando pagamento'
      />
      <InvoiceCard
        isLoading={isinvoicesBlockedLoading}
        invoices={invoicesBlocked}
        header='Serviços bloqueados'
      />
    </div>
  ) : (
    <span className='lead'>Bem-vindo</span>
  );
}
